module.exports = __webpack_public_path__ + "img/programme3.c138dd33.png";